import { AscResponse, IFetchPaymentPlansResponse } from '../../models';
import { httpService } from '../../utilities';
import { PaymentEndpoints } from './payment.endpoints';

interface IPaymentMethod {
  paymentMethodId: string;
}

interface ICreateSubscription {
  paymentMethodId: string;
  priceId: string;
}

interface IAddPaymentMethodFormType {
  firstname: string;
  lastname: string;
  country: string;
  city: string;
  address: string;
  state?: string;
  zipCode?: string;
  cardDetails: string;
  cvc: string;
  expirationDate: string;
}

interface IDownloadTransactions {
  fromDate?: string;
  toDate?: string;
  limit?: number;
  sortBy?: string;
  sortOrder?: string;
  ids: string[];
}
//Payment Plans --------------------
export async function getPaymentPlansApi() {
  return httpService
    .get<AscResponse<IFetchPaymentPlansResponse>>(
      PaymentEndpoints.getPaymentPlans
    )
    .then((res) => res.data.data);
}

//Payment Methods --------------------
export async function createPaymentMethodApi(body: IPaymentMethod) {
  return httpService
    .post(PaymentEndpoints.createPaymentMethod, body)
    .then((res) => res.data.data);
}

export async function deletePaymentMethodApi(methodId: string) {
  return httpService
    .delete(PaymentEndpoints.deletePaymentMethod + `/${methodId}`)
    .then((res) => res.data.data);
}

//Subscriptions --------------------

export async function createSubscription(body: ICreateSubscription) {
  return httpService
    .post(PaymentEndpoints.createSubscription, body)
    .then((res) => res.data.data);
}

export async function cancelSubscription() {
  return httpService
    .patch(PaymentEndpoints.cancelSubscription)
    .then((res) => res.data.data);
}

export async function updateSubscriptionPayment(body: ICreateSubscription) {
  return httpService
    .patch(PaymentEndpoints.updateSubscriptionPayment, body)
    .then((res) => res.data.data);
}

export async function purchaseSchoolCredits(body: {
  credits: number;
  paymentMethodId: string;
}) {
  return httpService
    .post(PaymentEndpoints.purchaseSchoolCredits, body)
    .then((res) => res.data.data);
}

export async function downloadTransactions(body: IDownloadTransactions) {
  return httpService
    .post(PaymentEndpoints.downloadTransactions, body, { responseType: 'blob' })
    .then((res) => res.data);
}

export async function downloadSchoolTransactions(body: IDownloadTransactions) {
  return httpService
    .post(PaymentEndpoints.downloadSchoolTransactions, body, {
      responseType: 'blob',
    })
    .then((res) => res.data);
}
